import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { toast } from 'react-toastify';
import { Alert, Badge, Modal, ModalBody, ModalHeader } from 'reactstrap';

import style from '../../styles/layout.module.css';
import request from '../../utils/useAxios';


const SortProductModel = ({
  menuId,
  openModal = false,
  setOpenModel = () => {},
}) => {
  const [products, setProducts] = useState([]);
  const sortProducts = useRef([]);

  const getAllProductList = useCallback(async () => {
    const res = await request({
      data: {
        menuId,
        order: '',
        order_by: '',
        page: 0,
        page_size: 0,
        type: 0,
      },
      method: 'post',
      url: '/Backend/Cafe_MealCoffeePrd/list',
    });
    if (res.code === 200) {
      return (res.result.datas || []).map((data, index) => {
        return {
          index: index + 1,
          ...data,
        };
      });
    } else {
      return [];
    }
  }, []);

  const sortProductList = useCallback(async products => {
    const res = await request({
      data: products.map((menu, index) => {
        return {
          id: menu.id,
          sort: index,
        };
      }),
      method: 'post',
      url: '/Backend/Cafe_MealCoffeePrd/prd/sort',
    });
    if (res.code === 200) {
      toast.success('修改完成');
      return res;
    } else {
      toast.success('修改失敗');
      throw res;
    }
  }, []);

  const handleOnDragEnd = result => {
    const { source, destination } = result;
    if (!destination) {
      return;
    }
    const [remove] = sortProducts.current.splice(source.index, 1);
    sortProducts.current.splice(destination.index, 0, remove);
    setProducts(sortProducts.current);
  };

  useEffect(() => {
    if (openModal) {
      getAllProductList().then(products => {
        setProducts(products);
        sortProducts.current = [...products];
      });
    }
  }, [openModal, getAllProductList, setProducts]);

  return (
    <div className={style.modal}>
      <Modal
        centered
        size="lg"
        isOpen={openModal}
        toggle={() => {
          sortProductList(products).then(() => {
            setOpenModel(false);
          });
        }}
        backdrop="static"
      >
        <ModalHeader
          className={style.modal_head}
          toggle={() => {
            sortProductList(products).then(() => {
              setOpenModel(false);
            });
          }}
        >
          商品選單排序
        </ModalHeader>
        <ModalBody>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="brands">
              {provided => (
                <ul
                  className="drag_list"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {products.map((menu, index) => (
                    <Draggable
                      key={menu.id}
                      draggableId={`${menu.id}`}
                      index={index}
                    >
                      {provided => (
                        <li
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                        >
                          <Alert color="warning" className="d-flex p-0 w-100">
                            <Badge className="d-flex align-items-center">
                              {menu.index}
                            </Badge>
                            <div className="p-3">{menu.name}</div>
                          </Alert>
                        </li>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default memo(SortProductModel);
